// AS ORGANIZAÇÕES QUE UMA TELA OPERACIONAL PODE ESCOLHER.
//
// A organização de teste (`tenantDeTeste`, item 9 do PENDENCIAS) sai das
// contagens sempre e da LISTAGEM por padrão — quem administra o cadastro a
// traz de volta pelo filtro. Só que as telas de operação (novo servidor,
// importar, convênio, rubricas, relações…) montavam o seletor com a mesma
// listagem, sem pedir os de teste, e o resultado era uma organização que
// existe mas não se alcança: dava para cadastrá-la e não dava para cadastrar
// um servidor nela (10/09/2026).
//
// "Não conta nos números" é sobre CONTAR, não sobre operar. Seletor de
// operação inclui a de teste, com o rótulo dizendo que é de teste.

import type { AdminPrefeitura } from "@atlas/sdk";
import { atlas } from "./sdk";

/** Prefixo `["admin", "prefeituras"]` de propósito: quem invalida a listagem
 *  depois de salvar uma organização invalida este recorte junto. */
export const QUERY_UNIDADES_OPERAVEIS = ["admin", "prefeituras", "operaveis"] as const;

export function listarUnidadesOperaveis() {
  return atlas.admin.listPrefeituras({ incluirTeste: "1" });
}

/** `Nome/UF`, e `(teste)` quando for organização de teste. */
export function rotuloUnidade(p: Pick<AdminPrefeitura, "nome" | "uf" | "tenantDeTeste">): string {
  return `${p.nome}/${p.uf}${p.tenantDeTeste ? " (teste)" : ""}`;
}
